import { getQueryParam } from "@circle-react/helpers/urlHelpers";

export const useVerificationQueryParams = () => {
  const paymentIntent = getQueryParam("payment_intent") || "";
  const paymentMethodType = getQueryParam("payment_method_type") || "";
  const wasForwarded = !!getQueryParam("forwarded");

  return {
    paymentIntent,
    paymentMethodType,
    wasForwarded,
    isVerifiable: !!paymentIntent,
  };
};
